import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';

// Global Selectors
import { makeSelectTimesheetValue } from 'services/timesheets/selectors';

interface OwnProps {
    timesheetId: number;
    children: React.ReactElement;
}

interface ConnectedProps {
    lastExportedAt?: string | null;
}

type Props = OwnProps & ConnectedProps;

export class TimesheetIsNotExportedGate extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, lastExportedAt } = this.props;
        if (lastExportedAt) {
            return null;
        }
        return children;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    lastExportedAt: makeSelectTimesheetValue('lastExportedAt')
});

export default connect(mapStateToProps)(TimesheetIsNotExportedGate);
